import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}

import { ref, onMounted } from 'vue';
import Modal from '@/shared/components/Modal.vue';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import useVuelidate, { ValidationRule } from '@vuelidate/core';
import { required, maxLength } from '@vuelidate/validators';
import VuelidateUtil from '@/shared/util/vuelidateUtil';
import { useStore } from 'vuex';
import Toast from '@shared/services/toast';
import { workspacesApi } from '@/workspaces/workspaces';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateWorkspaceModal',
  emits: ["workspace-created", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store = useStore();

const workspaceName = ref('');
const isLoading = ref(false);
const nameInput = ref<HTMLInputElement | null>(null);

// Validation rules for the flowName
const validations = {
  workspaceName: {
    required,
    maxLength: maxLength(250),
    workspaceNameValid: VuelidateUtil.objectName,
  },
};

const $v = useVuelidate(validations, { workspaceName });

onMounted(() => {
  if (nameInput.value) {
    nameInput.value.focus();
  }
});

async function createWorkspace() {
  if ($v.value.$invalid) {
    return;
  }

  isLoading.value = true;
  try {
    const newWorkspace = await workspacesApi.createWorkspace({
      name: workspaceName.value,
      features: {},
      usageLimits: {},
    });
    isLoading.value = false;
    emit('workspace-created', newWorkspace);
    close();
  } catch (e: any) {
    isLoading.value = false;
    if (e.status === 409) {
      Toast.showError(e.message);
      return;
    }
    Toast.showError('Failed to create workspace');
  }
}

function getErrorMessage() {
  return VuelidateUtil.getErrorMessage($v, 'workspaceName', 'Name', (validationRule: ValidationRule) => {
    if (VuelidateUtil.isValidationInvalid($v, 'workspaceName', 'workspaceNameValid')) {
      return 'Name must only contain letters, numbers, spaces, and the characters , - _ ( ) &';
    }
    return '';
  });
}

function close() {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createBlock(Modal, { onCancel: close }, {
    title: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("p", { class: "modal-card-title" }, "Create a Workspace", -1)
    ])),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("label", {
          for: "workspace-modal-name-input",
          class: "label"
        }, "Name", -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            id: "workspace-modal-name-input",
            ref_key: "nameInput",
            ref: nameInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((workspaceName).value = $event)),
            class: _normalizeClass(["input", { 'is-danger': _unref($v).workspaceName.$invalid && _unref($v).workspaceName.$dirty }]),
            type: "text",
            placeholder: "Enter the name of the workspace...",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).workspaceName.$touch())),
            onKeypress: _withKeys(createWorkspace, ["enter"])
          }, null, 34), [
            [_vModelText, workspaceName.value]
          ]),
          (_unref($v).workspaceName.$invalid && _unref($v).workspaceName.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(getErrorMessage()), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            onClick: createWorkspace,
            disabled: _unref($v).$invalid,
            loading: isLoading.value
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Create Workspace ")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, {
            onClick: close,
            variant: "primary--outline"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})